<template>
    <div
        class="stadic_layout_footer stadic_footer_height align_center button_container border_t"
    >
        <a
            href="javascript:void(0)"
            @click="canelBtn"
            class="common_button common_button_gray margin_t_10 "
        >{{cancelLabel}}</a
        >
        <a
            href="javascript:void(0)"
            @click="confirmBtn"
            class="common_button common_button_emphasize  margin_t_10 margin_r_10"
        >确定</a
        >
    </div>
</template>

<script>
    export default {
        name: "go-form-tool-bar",
        computed: {},
        props:{
            cancelLabel:{
                type:String,
                default:'取消',
            }
        },
        methods: {
            confirmBtn() {
                this.$emit("confirmBtn");
            },
            canelBtn() {
                this.$emit("canelBtn");
            }
        },
        mounted() {
        },
        components: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/formVue/go-form-tool-bar.vue